(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
/* Timeline – behavior unchanged */

function initTimeline(section) {
  if (!section || section.dataset.initialized) return;
  section.dataset.initialized = 'true';

  const nodes = section.querySelectorAll('.timeline-node');
  const panels = section.querySelectorAll('.timeline-panel');
  const panelContainer = section.querySelector('.timeline-panels');

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function closeAll() {
    nodes.forEach(n => n.classList.remove('is-active'));
    panels.forEach(p => {
      p.classList.remove('active');
      if (isMobile() && p.parentElement !== panelContainer) {
        panelContainer.appendChild(p);
      }
    });
  }

  nodes.forEach(node => {
    node.addEventListener('click', () => {
      const panel = section.querySelector('#' + node.dataset.target);
      if (!panel) return;

      const isOpen = panel.classList.contains('active');
      closeAll();

      if (!isOpen) {
        node.classList.add('is-active');
        panel.classList.add('active');

        if (isMobile()) {
          node.insertAdjacentElement('afterend', panel);
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-timeline]').forEach(initTimeline);
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-timeline]').forEach(initTimeline);
});

  } catch(e) { console.error(e); }
})();
})();
